export default {
    '$route': function() {
        const self = this

        self.question = {
            question: null,
            answer: null
        }
        self.resetFormResult()
    }
}
